const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7398,-1087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_13",
    transform: "matrix(1,0,0,1,7398.1,1087.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(193,114,145)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4624,0,0,1.51883,-236.748,-408.039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.777697,0,0,0.777697,-5639.66,-714.234)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.914149,0.405378,-0.405378,0.914149,-5939.91,-4164.94)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.914149,0.405378,0.405378,0.914149,6963.91,-4164.94)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13978,0,0,1.13978,-8503.75,-1192.37)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04193,0.462041,-0.462041,1.04193,-6834.09,-4686.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.04193,0.462041,0.462041,1.04193,7858.09,-4686.15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.702979,0,0,0.698487,-5048.64,-682.061)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05422,0,0,1.01442,-7827.89,-1324.9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.693153,0.307378,-0.307378,0.693153,-4374.93,-3132.54)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.693153,0.307378,0.307378,0.693153,5398.93,-3132.54)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7910.1,
    cy: 1678.03,
    rx: 46.291,
    ry: 62.254,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7398.1,-1092.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7932.77,1875.4C7932.77,1863.59 7922.8,1854 7910.53,1854C7898.26,1854 7888.3,1863.59 7888.3,1875.4L7888.3,1959.55C7888.3,1971.37 7898.26,1980.96 7910.53,1980.96C7922.8,1980.96 7932.77,1971.37 7932.77,1959.55L7932.77,1875.4Z",
    style: {
      fill: "white"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.828d1ef65581f4e04c88065ea51175b7.svg";
export { ForwardRef as ReactComponent };